export default [
	{ id: 'de', name: 'german' },
	{ id: 'en', name: 'english' }
];
